import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

const SectionPictos = ({ title, text }) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulCategorie {
        nodes {
          name
          picto {
            file {
              url
            }
          }
        }
      }
    }
  `)
  return (
    <section className="padding">
      <h2 className="text-capitalize mb-2 text-center">{title}</h2>
      <div className="mb-2 text-center">{text}</div>
      <div className="grid-x align-stretch align-justify">
        {data.allContentfulCategorie.nodes.map(category => {
          return (
            <div className="cell small-6 medium-auto">
              <div className="card--picto" key={category.name}>
                <h3 className="text-capitalize mb-2">{category.name}</h3>
                <img
                  className="card--picto__picto"
                  src={category.picto.file.url}
                  alt={category.name}
                  width="100px"
                  height="100px"
                />
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default SectionPictos
